import { NgModule } from '@angular/core';

import { LoginModule } from './authentication/login/login.module';
import { ForgotPasswordModule } from './authentication/forgot-password/forgot-password.module';
import { ResetPasswordModule } from './authentication/reset-password/reset-password.module';
import { MailConfirmModule } from './authentication/mail-confirm/mail-confirm.module';
import { PrivacyModule } from './privacy/privacy.module';
import { ServerInfoModule } from './server-info/server-info.module';


@NgModule({
    imports: [
        // Auth
        LoginModule,
        ForgotPasswordModule,
        ResetPasswordModule,
        MailConfirmModule,
        PrivacyModule,
      ServerInfoModule
    ]
})
export class PagesModule
{
}
